/**
 * Большая жёлтая CTA «Оформить подписку со скидкой 30% →» в нижней части
 * Главной (после списка карточек). Высота 56px (token tap-chip-lg).
 *
 * Источник истины — прототип `screen-2-home.html` строка 450.
 * Phase 1 — клик ведёт на stub-handler из Container'а.
 */
export interface SubscribeCTAProps {
  onClick: () => void;
}

export function SubscribeCTA({ onClick }: SubscribeCTAProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Оформить подписку"
      className={
        'w-full font-bold rounded-xl flex items-center justify-center gap-2 ' +
        'bg-cta text-ink border-b-2 border-cta-shadow min-h-tap-chip-lg ' +
        'focus-visible:ring-2 focus-visible:ring-cta focus-visible:ring-offset-2 ' +
        'focus-visible:outline-none transition-opacity active:opacity-90'
      }
      style={{ fontSize: 20, letterSpacing: '0.01em' }}
    >
      Оформить подписку со скидкой 30% →
    </button>
  );
}
